import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_SCORING_RESULTS_REPORT_ENTRIES_COUNT } from "../../types";
import {
  getScoringResultsReportEntriesCountPending,
  getScoringResultsReportEntriesCountFulfilled,
  getScoringResultsReportEntriesCountRejected,
} from "../../actions";
import { sendApiRequest, notifyError } from "../../../../actions";
import { EXPORT_SCORING_RESULTS_REPORT_CSV_MESSAGES } from "../../constants/exportScoringResultsReportCsvMessages";
import generateError from "../../../../utilities/generateError";
import { setScoringResultsNoEntriesMessage } from "../../actions";
const createPayload = (payload) => ({
  method: "get",
  url: "client/ScoringExportInfoCount",
  onSuccess: [
    (response) =>
      response.data === 0
        ? setScoringResultsNoEntriesMessage(
            EXPORT_SCORING_RESULTS_REPORT_CSV_MESSAGES.NOT_FOUND
          )
        : { type: "" },
    (response) => getScoringResultsReportEntriesCountFulfilled(response),
  ],
  onError: [
    getScoringResultsReportEntriesCountRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getScoringResultsReportEntriesCountEpic$ = (action$) =>
  action$.pipe(
    ofType(GET_SCORING_RESULTS_REPORT_ENTRIES_COUNT.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) =>
      merge(
        of(getScoringResultsReportEntriesCountPending()),
        of(sendApiRequest(createPayload(payload), meta))
      )
    )
  );

export default getScoringResultsReportEntriesCountEpic$;



// WEBPACK FOOTER //
// ./src/features/reports/epics/scoring-results/getScoringResultsReportEntriesCount.js